import { combineEpics } from 'redux-observable';

import { createEventCategoryEpic }   from './CreateEventCategory/CreateEventCategoryEpic';
import { deleteEventCategoryEpic }   from './DeleteEventCategory/DeleteEventCategoryEpic';
import { findEventCategoriesEpic }   from './FindEventCategories/FindEventCategoriesEpic';
import { searchEventCategoriesEpic } from './SearchEventCategories/SearchEventCategoriesEpic';
import { findEventCategoryEpic }     from './FindEventCategory/FindEventCategoryEpic';
import { updateEventCategoryEpic }   from './UpdateEventCategory/UpdateEventCategoryEpic';


export const eventCategoryEpics = combineEpics(
  createEventCategoryEpic,
  deleteEventCategoryEpic,
  searchEventCategoriesEpic,
  findEventCategoriesEpic,
  findEventCategoryEpic,
  updateEventCategoryEpic,
);
